import { render, staticRenderFns } from "./configStatusLevel.vue?vue&type=template&id=40094d48"
import script from "./configStatusLevel.vue?vue&type=script&lang=js"
export * from "./configStatusLevel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports